import { render } from "./CobranzaFueraDeRuta.vue?vue&type=template&id=5716926d"
import script from "./CobranzaFueraDeRuta.vue?vue&type=script&lang=js"
export * from "./CobranzaFueraDeRuta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__